<footer class="relative bg-[#1D4BA6] text-white py-10">
  <!-- Background Image -->
  <div class="absolute inset-0">
    <img src="/415.jpg" alt="Footer Background" class="w-full h-full object-cover" />
    <div class="absolute inset-0 bg-[#1D4BA6] opacity-30"></div>
  </div>

  <div class="relative max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
    <div>
      <h3 class="text-xl font-semibold mb-4">Sriee Holdings</h3>
      <p class="text-gray-300 text-sm leading-relaxed">
        Sriee Holdings PTE. Ltd. (202401721W)<br />
        1 Raffles Place<br />
        #34-04 One Raffles Place<br />
        Singapore 048616<br />
        Singapore<br />
        <span class="block mt-2">+65 9113 0004‬ &amp; 05</span>
      </p>
    </div>

    <div class="flex flex-col md:items-center">
      <h4 class="text-lg font-semibold mb-4"><span class="text-white">🔗</span> Quick Links</h4>
      <ul class="space-y-2 text-gray-300">
        <li class="flex items-center gap-2">
          <span class="text-white">•</span>
          <a href="#about" class="hover:text-[#E17A17] transition cursor-pointer">About</a>
        </li>
        <li class="flex items-center gap-2">
          <span class="text-white">•</span>
          <a href="#sectors" class="hover:text-[#E17A17] transition cursor-pointer">Sectors</a>
        </li>
        <li class="flex items-center gap-2">
          <span class="text-white">•</span>
          <a href="#presence" class="hover:text-[#E17A17] transition cursor-pointer">Global Presence</a>
        </li>
        <li class="flex items-center gap-2">
          <span class="text-white">•</span>
          <a href="#contact" class="hover:text-[#E17A17] transition cursor-pointer">Contact</a>
        </li>
        <li class="flex items-center gap-2">
          <span class="text-white">•</span>
          <a href="#privacy" class="hover:text-[#E17A17] transition cursor-pointer">Privacy</a>
        </li>
      </ul>
    </div>


    <div class="flex md:justify-end items-center">
      <img src="/Sriee_logo.png" alt="Sriee Holdings Logo"
        class="h-12 md:h-14 lg:h-16 w-auto object-contain bg-white p-2 rounded" />
    </div>

    <!-- <div class="md:text-right">
      <h4 class="text-lg font-semibold mb-4">Follow Us</h4>
      <div class="flex md:justify-end space-x-4">
        <a href="https://linkedin.com" target="_blank" class="text-gray-300 hover:text-[#E17A17] transition">
          <i class="fab fa-linkedin fa-2x"></i>
        </a>
        <a href="https://twitter.com" target="_blank" class="text-gray-300 hover:text-[#E17A17] transition">
          <i class="fab fa-x-twitter fa-2x"></i>
        </a>
        <a href="https://facebook.com" target="_blank" class="text-gray-300 hover:text-[#E17A17] transition">
          <i class="fab fa-facebook fa-2x"></i>
        </a>
        <a href="https://instagram.com" target="_blank" class="text-gray-300 hover:text-[#E17A17] transition">
          <i class="fab fa-instagram fa-2x"></i>
        </a>
      </div>
    </div> -->
  </div>

  <div
    class="relative mt-10 border-t border-gray-400 pt-6 text-center text-white text-sm flex flex-col md:flex-row justify-center md:justify-between items-center space-y-3 md:space-y-0 px-6">
    <span>© 2025 Sriee Holdings. All Rights Reserved.</span>

    <a href="https://1sports.app" target="_blank" rel="noopener noreferrer"
      class="text-white hover:text-[#E17A17] transition">
      Powered by 1Sports
    </a>

    <div class="space-x-4">
      <a routerLink="/privacy" class="hover:text-[#E17A17] transition cursor-pointer">Privacy Policy</a>
      <a routerLink="/terms" class="hover:text-[#E17A17] transition cursor-pointer">Terms & Conditions</a>
    </div>
  </div>
</footer>